export const origins = {
    EMAIL: 'Email',
    PHONE: 'Teléfono',
    ATA_OFFICE: 'Oficina ATA',
    WORK: 'Desde el trabajo',
    NOT_SPECIFIED: 'No especificado',
    WHATSAPP: 'Whatsapp',
};

export const states = {
    OPEN: 'Abierta',
    RESOLVED: 'Resuelta',
    CLOSED: 'Cerrada',
    REOPEN: 'Reabierta',
    REASSIGNED: 'Reasignada'
};